import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import AgeGate from "./components/AgeGate";
import { Toaster } from "sonner";

function App() {
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        const ok = localStorage.getItem("high95_age_verified");
        if (ok === "yes") setVerified(true);
        document.documentElement.classList.add("dark");
    }, []);

    const handleVerify = () => {
        localStorage.setItem("high95_age_verified", "yes");
        setVerified(true);
    };

    return (
        <div className="App min-h-screen bg-background text-foreground">
            <BrowserRouter>
                {!verified && <AgeGate onVerify={handleVerify} />}
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#0C0D11",
                        color: "#fff",
                        border: "1px solid rgba(255,255,255,0.08)",
                    },
                }}
            />
        </div>
    );
}

export default App;
